'use client';

import { __awaiter, __generator } from '../../_virtual/_tslib.js';
import React__default, { useState, useCallback, useMemo } from 'react';
import { DeleteContent, LabelWrapper, ResumeItemWrapper, CvSection, FileName, JustUploadTag, NotApprovedTag, TagSearchable, LabelWithIcon, Dot, Link, ErrorMessage } from './ResumeItem.css.js';
import { fileName, dateToString } from '../../ApplyJobsForm/helper.js';
import { ALLOW_SEARCHABLE, EResumeType } from '../../ApplyJobs/constants.js';
import { EApplyType } from '../../services/resumes/types.js';
import { colors } from '../../Colors/index.js';
import SingleRadio from '../../SingleRadio/index.js';
import Typography from '../../Typography/index.js';
import Col from '../../LayoutSystem/Col.js';
import Row from '../../LayoutSystem/Row.js';
import '../../Images/AddIcon/index.js';
import '../../Images/AddOutlinedIcon/index.js';
import Trash from '../../Images/Trash/index.js';
import '../../Images/Pencil/index.js';
import '../../Images/ArrowRoundedLeft/index.js';
import '../../Images/ArrowRoundedRight/index.js';
import '../../Images/AwardsIcon/index.js';
import '../../Images/BonusIcon/index.js';
import '../../Images/CanteenIcon/index.js';
import '../../Images/CheckTagIcon/index.js';
import '../../Images/CommercialIcon/index.js';
import '../../Images/CompanySizeIcon/index.js';
import '../../Images/ContactIcon/index.js';
import '../../Images/CopyIcon/index.js';
import '../../Images/DefaultAvatar/index.js';
import '../../Images/DangerIcon/index.js';
import '../../Images/ExternalLinkIcon/index.js';
import EyesOpenIcon from '../../Images/EyesOpenIcon/index.js';
import '../../Images/FacebookIcon/index.js';
import '../../Images/ForwardIcon/index.js';
import '../../Images/HealthcarePlanIcon/index.js';
import '../../Images/HeartIcon/index.js';
import '../../Images/HeartOutlineIcon/index.js';
import '../../Images/HideIcon/index.js';
import '../../Images/KindergartenIcon/index.js';
import '../../Images/LaptopIcon/index.js';
import '../../Images/LibraryIcon/index.js';
import '../../Images/LinkIcon/index.js';
import '../../Images/LinkedInIcon/index.js';
import '../../Images/LoadingCircleIcon/index.js';
import '../../Images/MarkerIcon/index.js';
import '../../Images/MobileIcon/index.js';
import '../../Images/PaidLeaveIcon/index.js';
import { ELanguage } from '../../Utils/constants.js';
import '../../Images/SearchIcon/index.js';
import '../../Images/ShareIcon/index.js';
import '../../Images/ReportIcon/index.js';
import '../../Images/StatsIcon/index.js';
import '../../Images/TeamActivitiesIcon/index.js';
import '../../Images/ThreeDotIcon/index.js';
import '../../Images/TrainingIcon/index.js';
import '../../Images/TransportationIcon/index.js';
import '../../Images/TrashIcon/index.js';
import '../../Images/TravelOpportunitiesIcon/index.js';
import '../../Images/VerticalMoreIcon/index.js';
import '../../Images/VoucherIcon/index.js';
import WarningIcon from '../../Images/Warning/index.js';
import '../../Images/WowCVIcon/index.js';
import '../../Images/WorkingLocationIcon/index.js';
import '../../Images/ZaloIcon/index.js';
import '../../Images/FacebookLogoIcon/index.js';
import '../../Images/GoogleLogoIcon/index.js';
import '../../Images/DragReorderIcon/index.js';
import '../../Images/CheckIcon/index.js';
import '../../Images/CircleChecked/index.js';
import '../../Images/SalaryIcon/index.js';
import '../../Images/BriefcaseIcon/index.js';
import '../../Images/GraduationCapIcon/index.js';
import '../../Images/EnvelopeIcon/index.js';
import '../../Images/AddFilledIcon/index.js';
import '../../Images/HomeIcon/index.js';
import '../../Images/PhoneIcon/index.js';
import AttachIcon from '../../Images/AttachIcon/index.js';
import '../../Images/FilterIcon/index.js';
import '../../icons/WarnIcon.js';
import '../../icons/AccountSettingsIcon.js';
import '../../icons/DashboardIcon.js';
import '../../icons/JobAlertsIcon.js';
import '../../icons/MyCompaniesIcon.js';
import '../../icons/MyJobsIcon.js';
import '../../icons/MyProfileIcon.js';
import '../../icons/ProfileSettingsIcon.js';
import '../../icons/LanguageIcon.js';
import '../../icons/BenefitGroupIcons/ActivityIcon.js';
import '../../icons/BenefitGroupIcons/AwardsIcon.js';
import '../../icons/BenefitGroupIcons/BonusIcon.js';
import '../../icons/BenefitGroupIcons/CanteenIcon.js';
import '../../icons/BenefitGroupIcons/HealthcareIcon.js';
import '../../icons/BenefitGroupIcons/KindergartenIcon.js';
import '../../icons/BenefitGroupIcons/LaptopIcon.js';
import '../../icons/BenefitGroupIcons/LibraryIcon.js';
import '../../icons/BenefitGroupIcons/MoreIcon.js';
import '../../icons/BenefitGroupIcons/PaidLeaveIcon.js';
import '../../icons/BenefitGroupIcons/PhoneIcon.js';
import '../../icons/BenefitGroupIcons/TrainingIcon.js';
import '../../icons/BenefitGroupIcons/TransportationIcon.js';
import '../../icons/BenefitGroupIcons/TravelIcon.js';
import '../../icons/BenefitGroupIcons/VoucherIcon.js';
import '../../icons/BenefitGroupIcons/Physics.js';
import '../../icons/BenefitGroupIcons/WorkingHourIcon.js';
import '../../icons/BenefitGroupIcons/WorkingDayIcon.js';
import '../../icons/BenefitGroupIcons/WorkingTypeIcon.js';
import '../../icons/AccountCenterGroupIcons/ChartVertical.js';
import '../../icons/AccountCenterGroupIcons/Language.js';
import '../../icons/AccountCenterGroupIcons/EmptyHotCategory.js';
import '../../icons/AccountCenterGroupIcons/Lawyer.js';
import '../../icons/InfoOverviewGroupIcons/CompanySize.js';
import '../../icons/InfoOverviewGroupIcons/Location.js';
import '../../icons/InfoOverviewGroupIcons/Education.js';
import '../../icons/InfoOverviewGroupIcons/PhoneNumber.js';
import '../../icons/InfoOverviewGroupIcons/CalendarIOS16Glyph.js';
import '../../icons/InfoOverviewGroupIcons/Admin.js';
import '../../icons/InfoOverviewGroupIcons/HeadHunter.js';
import '../../icons/InfoOverviewGroupIcons/Address.js';
import '../../icons/InfoOverviewGroupIcons/Salary.js';
import '../../icons/InfoOverviewGroupIcons/Gender.js';
import '../../icons/InfoOverviewGroupIcons/Translator.js';
import '../../icons/InfoOverviewGroupIcons/Birthday.js';
import '../../icons/InfoOverviewGroupIcons/LocationIOS16Glyph.js';
import '../../icons/InfoOverviewGroupIcons/CreditIcon.js';
import '../../icons/MiscGroupIcons/Link.js';
import '../../icons/MiscGroupIcons/History.js';
import '../../icons/MiscGroupIcons/Favorite.js';
import '../../icons/MiscGroupIcons/UnFavorite.js';
import '../../icons/MiscGroupIcons/ProductDocuments.js';
import '../../icons/MiscGroupIcons/Star.js';
import '../../icons/SocialMediaGroupIcons/Facebook.js';
import '../../icons/SocialMediaGroupIcons/Linkedin.js';
import '../../icons/SocialMediaGroupIcons/Twitter.js';
import '../../icons/SocialMediaGroupIcons/Zalo.js';
import '../../icons/SocialMediaGroupIcons/FacebooksColorFull.js';
import '../../icons/SocialMediaGroupIcons/LinkedinColorFull.js';
import '../../icons/SocialMediaGroupIcons/TwitterColorFull.js';
import '../../icons/SocialMediaGroupIcons/ZaloColorFull.js';
import '../../icons/SocialMediaGroupIcons/Share.js';
import '../../icons/NavigationGroupIcons/Vertical.js';
import '../../icons/NavigationGroupIcons/More.js';
import '../../icons/NavigationGroupIcons/Close.js';
import '../../icons/NavigationGroupIcons/Expand.js';
import '../../icons/NavigationGroupIcons/Collapse.js';
import '../../icons/NavigationGroupIcons/Next.js';
import '../../icons/NavigationGroupIcons/Back.js';
import '../../icons/NavigationGroupIcons/ExternalLink.js';
import '../../icons/NavigationGroupIcons/RightArrow.js';
import '../../icons/AlertGroupIcons/SuccessIcon.js';
import '../../icons/AlertGroupIcons/CareerPath.js';
import '../../icons/AlertGroupIcons/Hot.js';
import '../../icons/AlertGroupIcons/Urgent.js';
import '../../icons/FormActionGroupIcons/Exchange.js';
import '../../icons/FormActionGroupIcons/AddTag.js';
import '../../icons/RewardsTypeGroupIcons/Hospital.js';
import '../../Images/DoubleTickIcon/index.js';
import '../../Images/BellIcon/index.js';
import '../../Images/AiIcon/index.js';
import '../../Images/MiniAiIcon/index.js';
import '../../icons/OrderManagementIcon.js';
import '../../Images/TwinkleLinearGradientIcon/index.js';
import translations from '../../ApplyJobs/translations.js';
import { deleteAttachedResume } from '../../services/ai-review/index.js';
import { DEFAULT_SUCCESS_CODE } from '../../services/resumes/const.js';
import ButtonViewMore from '../../ButtonViewMore/index.js';
import Popup from '../../Popup/index.js';
import { showToast } from '../../Toast/index.js';
import { isMobile, downloadAttachFile } from '../../Utils/helpers.js';
import '../../Cascader/constants.js';

var ResumeItem = function (props) {
    var _a, _b, _c;
    var radioId = props.radioId, resumeId = props.resumeId, cvInfo = props.cvInfo, isAttach = props.isAttach, profileStrength = props.profileStrength, baseUrl = props.baseUrl, msBaseUrl = props.msBaseUrl, accessToken = props.accessToken, langCode = props.langCode, isAIParseError = props.isAIParseError, isDeletable = props.isDeletable, onChange = props.onChange, setIsLoadingResumes = props.setIsLoadingResumes, handleGetResume = props.handleGetResume, applyResumeId = props.applyResumeId;
    var _d = useState(false), isShowDelete = _d[0], setShowDelete = _d[1];
    var _e = useState(false), isLockView = _e[0], setLockView = _e[1];
    var t = useCallback(function (text) {
        var _a;
        if (props.langCode === ELanguage.VI) {
            return (_a = translations[text]) !== null && _a !== void 0 ? _a : text;
        }
        return text;
    }, [props.langCode]);
    var isSelected = (cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.id) === resumeId;
    var isDisabled = !isAttach && (cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.allowSearchableDisplay) !== ALLOW_SEARCHABLE;
    var onChangeRadio = function () {
        var _a;
        if (isDisabled) {
            return;
        }
        var isAttach = cvInfo.isAttach === EResumeType.ATTACH;
        var applyType = isAttach ? EApplyType.lastAttachment : EApplyType.online;
        onChange({
            resumeId: (_a = cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.id) !== null && _a !== void 0 ? _a : -1,
            type: applyType
        });
    };
    var onClickViewResume = function () {
        var _a;
        if (isMobile()) {
            window.open("".concat(baseUrl, "/").concat(t('preview-resume'), "/").concat(cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.id), '_blank');
            return;
        }
        if (!isAttach) {
            window.open("".concat(baseUrl, "/").concat(t('my-profile')), '_blank');
            return;
        }
        if (!(cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.id) || isLockView) {
            return;
        }
        var body = props.isJustUploaded ? { type: 2 } : null;
        downloadAttachFile({
            resumeId: cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.id,
            downloadRequest: 'new-window',
            msBaseUrl: msBaseUrl !== null && msBaseUrl !== void 0 ? msBaseUrl : '',
            accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : '',
            fileName: (_a = cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.fileName) !== null && _a !== void 0 ? _a : '',
            body: body,
            onOpenOrDownload: function () { return setLockView(false); }
        });
    };
    var onClickDeleteConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var deleteResponse;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.id)) {
                        return [2 /*return*/];
                    }
                    setIsLoadingResumes(true);
                    return [4 /*yield*/, deleteAttachedResume({
                            resumeId: cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.id,
                            langCode: langCode,
                            msBaseUrl: msBaseUrl,
                            accessToken: accessToken
                        })];
                case 1:
                    deleteResponse = _b.sent();
                    if (((_a = deleteResponse === null || deleteResponse === void 0 ? void 0 : deleteResponse.meta) === null || _a === void 0 ? void 0 : _a.code) === DEFAULT_SUCCESS_CODE) {
                        showToast(t('Success'), t('Delete CV successfully'));
                    }
                    setShowDelete(false);
                    // Trigger reload resume
                    handleGetResume();
                    return [2 /*return*/];
            }
        });
    }); };
    var viewMoreOptions = useMemo(function () {
        var returnOptions = [
            {
                label: t('View'),
                icon: React__default.createElement(EyesOpenIcon, null),
                isCloseOnClick: false,
                onClick: onClickViewResume
            }
        ];
        if (isAttach && isDeletable) {
            returnOptions.push({
                label: t('Delete'),
                icon: React__default.createElement(Trash, null),
                isCloseOnClick: true,
                onClick: function () { return setShowDelete(true); }
            });
        }
        return returnOptions;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAttach, isDeletable]);
    var labelColor = isSelected ? colors.primary[40] : colors.grey[20];
    if (!isAttach && isDisabled) {
        labelColor = colors.grey[50];
    }
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Popup, { lang: langCode, isShow: isShowDelete, onClose: function () { return setShowDelete(false); }, onClickOutside: function () { return setShowDelete(false); }, onClickPrimary: onClickDeleteConfirm, text: {
                primaryBtn: t('Delete'),
                secondaryBtn: t('Cancel'),
                header: t('Delete the attached CV')
            }, styleOption: {
                size: 'xs',
                isFooterButtonFullWidth: true,
                primaryBtnOutline: 'outline',
                primaryBtnStyle: 'danger'
            }, option: {
                isCenterFooter: false
            } },
            React__default.createElement(DeleteContent, null,
                React__default.createElement("p", null, t('The attached CV “{0}” will be deleted from our system.').replace('{0}', (_a = cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.fileName) !== null && _a !== void 0 ? _a : '')),
                React__default.createElement("p", null, t('Are you sure to delete it?')))),
        React__default.createElement(LabelWrapper, { htmlFor: "".concat(radioId, "-apply-type-radio-button") },
            React__default.createElement(ResumeItemWrapper, { isSelected: isSelected, isDisabled: !isAttach && isDisabled, align: 'middle' },
                React__default.createElement(Col, { xs: 'auto' },
                    React__default.createElement(SingleRadio, { id: radioId, name: 'apply-type', disabled: isDisabled, checked: isSelected, onChange: onChangeRadio, noBg: true })),
                React__default.createElement(CvSection, { xs: 'fill' },
                    React__default.createElement(FileName, { name: 'label', size: 'medium', color: labelColor },
                        isAttach
                            ? fileName((_b = cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.fileName) !== null && _b !== void 0 ? _b : '', isMobile() ? 15 : 25)
                            : t('VietnamWorks profile'),
                        ' ',
                        props.isJustUploaded && React__default.createElement(JustUploadTag, null, t('Just uploaded')),
                        !isAttach && isDisabled && React__default.createElement(NotApprovedTag, null, t('Not approved')),
                        cvInfo.id === applyResumeId ? (React__default.createElement(TagSearchable, null, t('Job applied'))) : (cvInfo.isSearchable === 1 && React__default.createElement(TagSearchable, null, t('Searchable')))),
                    React__default.createElement(Row, { align: 'middle', gutter: { xs: 0, sm: 6 } },
                        React__default.createElement(Col, { xs: 24, sm: 'auto' },
                            React__default.createElement(Typography, { name: 'body', size: 'small', color: colors.grey[50], style: { display: 'flex', alignItems: 'center' } }, isAttach ? (React__default.createElement(LabelWithIcon, null,
                                React__default.createElement(AttachIcon, { width: 14, height: 14, color: colors.grey[50] }),
                                ' ',
                                t('Attached resume'),
                                ' ')) : (t('Profile online')))),
                        React__default.createElement(Dot, { variant: 'span', name: 'body', size: 'small', color: colors.grey[50] }, "\u2022"),
                        React__default.createElement(Col, { xs: 24, sm: 'auto' },
                            React__default.createElement(Typography, { name: 'body', size: 'small', color: colors.grey[50] },
                                isAttach ? (React__default.createElement(React__default.Fragment, null,
                                    t('Uploaded:'),
                                    " ",
                                    dateToString((_c = cvInfo === null || cvInfo === void 0 ? void 0 : cvInfo.lastProcessedOn) !== null && _c !== void 0 ? _c : ''))) : (React__default.createElement(React__default.Fragment, null,
                                    t('Completed:'),
                                    " ",
                                    profileStrength,
                                    "%")),
                                ' ')),
                        !isAttach && isDisabled ? (React__default.createElement(React__default.Fragment, null,
                            React__default.createElement(Dot, { variant: 'span', name: 'body', size: 'small', color: colors.grey[50] }, "\u2022"),
                            React__default.createElement(Col, { xs: 24, sm: 'auto' },
                                React__default.createElement(Typography, { name: 'body', size: 'small' },
                                    React__default.createElement(Link, { name: 'body', size: 'small', href: t('/my-profile'), color: colors.primary[40] }, t('Update profile')))))) : null)),
                React__default.createElement(Col, { xs: 'auto' },
                    React__default.createElement(ButtonViewMore, { options: viewMoreOptions, textOptions: {
                            closeText: t('Close')
                        }, styleOptions: {
                            customPadding: '8px'
                        } }))),
            isAIParseError ? (React__default.createElement(ErrorMessage, null,
                React__default.createElement(Typography, { name: 'paragraph', size: 'small', color: '#333' },
                    React__default.createElement(WarningIcon, { width: 16, height: 16, fill: colors.yellow[40] }),
                    t('We cannot process this file. Please ensure that the selected file contains the content of a CV and does not include too many images.')))) : null)));
};

export { ResumeItem as default };
//# sourceMappingURL=ResumeItem.js.map
